import React from 'react';

import Portal from '@src/components/ui2/Portal';

import { Header, IconButton, Overlay, StyledPaper, Title } from './styles';
import { MdClose } from 'react-icons/md';
import useModalOverlayLock from '@src/hooks/useModalOverlayLock';

type ModalProps = {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  width?: number;
  title?: string;
  showCloseButton?: boolean;
  slots?: {
    Content: ({ width }: { width?: number }) => JSX.Element;
  };
};

export const Modal = (props: ModalProps) => {
  const { open, onClose = () => {}, children, width = 600, title, showCloseButton = true } = props;

  useModalOverlayLock(open);

  const onClickOverlay = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const Content = props.slots?.Content ?? StyledPaper;

  return (
    <>
      {open ? (
        <Portal>
          <Overlay className='planne-widget-modal' onClick={onClickOverlay}>
            <Content width={width}>
              {title || showCloseButton ? (
                <Header>
                  {title ? <Title>{title}</Title> : null}

                  {showCloseButton ? (
                    <IconButton onClick={onClose}>
                      <MdClose size={24} />
                    </IconButton>
                  ) : null}
                </Header>
              ) : null}

              {children}
            </Content>
          </Overlay>
        </Portal>
      ) : null}
    </>
  );
};

export default Modal;
